import { Paper, Typography, Box } from '@mui/material';
import React, { PureComponent } from 'react';

interface CoordinateDisplayOverlayProps {
  latitude: number | null;
  longitude: number | null;
}

export default class CoordinateDisplayOverlay extends PureComponent<CoordinateDisplayOverlayProps> {
  formatCoordinate(value: number | null): string {
    if (value === null) {
      return '--';
    }

    return value.toFixed(6);
  }

  render() {
    const { latitude, longitude } = this.props;

    return (
      <Paper
        square
        className="coordinate-display-overlay"
        style={{
          position: 'absolute',
          top: 125,
          left: 10,
          zIndex: 1000,
          padding: 10,
          minWidth: 200,
        }}
      >
        <Box>
          <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 4 }}>
            Coordinates
          </Typography>
          <Typography variant="body2">Lat: {this.formatCoordinate(latitude)}</Typography>
          <Typography variant="body2">Lon: {this.formatCoordinate(longitude)}</Typography>
        </Box>
      </Paper>
    );
  }
}
